import { Controller } from "@hotwired/stimulus"

const SCROLL_KEY = "admin-sidebar-nav-scroll"

export default class extends Controller {
  static targets = ["nav"]

  connect() {
    // 遷移後、新しい nav が接続されたタイミングで保存済みスクロール位置を復元する。
    // Stimulus の connect は Turbo の render 完了後に呼ばれる。
    if (this.hasNavTarget) {
      const saved = sessionStorage.getItem(SCROLL_KEY)
      if (saved !== null) this.navTarget.scrollTop = Number(saved)
    }

    // DOM が差し替えられる直前（要素がまだドキュメント上にある）に scrollTop を保存する。
    // disconnect タイミングでは要素が切り離され scrollTop が 0 を返すため使えない。
    this.savePosition = this.savePosition.bind(this)
    document.addEventListener("turbo:before-cache", this.savePosition)
    document.addEventListener("turbo:before-visit", this.savePosition)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.savePosition)
    document.removeEventListener("turbo:before-visit", this.savePosition)
  }

  savePosition() {
    if (!this.hasNavTarget) return
    sessionStorage.setItem(SCROLL_KEY, String(this.navTarget.scrollTop))
  }

  toggle() {
    this.element.toggleAttribute("data-collapsed")
    const collapsed = this.element.hasAttribute("data-collapsed")
    document.cookie = `sidebar_collapsed=${collapsed};path=/;max-age=${60 * 60 * 24 * 365};SameSite=Lax`
  }
}
